

















































import Vue from 'vue'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import _ from 'lodash'
import { GridOptions } from '@/types'
import { hexToRgba } from '@/services/hex-to-rgba'
import AddressResponsibleEmployeeDialog from '@/components/master-data/address/AddressResponsibleEmployeeDialog.vue'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import {
  ADDRESS_RESPONSIBLE_EMPLOYEE, COMPANY_FETCH_COMPANY_STRUCTURE,
  FETCH_ADDRESS_FUNCTION_LIST,
  FETCH_ADDRESS_RESPONSIBLE_EMPLOYEE_LIST
} from '@/store/action-types'
import { ResponsibleEmployee } from '@/model/addresses/ResponsibleEmployee'
import { AddressFunction } from '@/model/addresses/AddressFunction'
import { COMPANY_GET_BASIC_COMPANY_STRUCTURE } from '@/store/getter-types'
import { Employee } from '@/model/companyStructure/Employee'
import AddressColorCellRenderer from '@/components/cell-renderer/AddressColorCellRenderer.vue'
import { ResponseBase, VerantwortungsDataResponse } from '@/types/service-response'
import { UpdateVerantwortungsDataRequest, VerantwortungsInput } from '@/types/payload'

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  gridOptions: GridOptions
  gridFrameworkComponents: Object
  overlayNoRowsTemplate: string
  functionList: AddressFunction[]
  employeeList: Employee[]
  responsibleEmployeeList: ResponsibleEmployee[]
  selectedResponsibleEmployee: ResponsibleEmployee | undefined
  showDialog: boolean
  dialogTitle: string
  showDeleteDialog: boolean
  loading: boolean
}

export default Vue.extend({
  name: 'AddressResponsibleEmployees',

  components: {
    AgGridVue,
    AddressResponsibleEmployeeDialog,
    DeleteDialog
  },

  props: {
    addressId: Number
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('masterData.addresses.function'), field: 'functionLabel' },
          { headerName: this.$t('masterData.addresses.employee'), field: 'employeeName' },
          { headerName: this.$t('masterData.addresses.personalNumber'), field: 'personalNumber' },
          { headerName: this.$t('masterData.addresses.shortName'), field: 'shortName'},
          { headerName: this.$t('masterData.addresses.alreadyAssignedAdddressColours'), field: 'farben', width: 700, cellRenderer: 'addressColorRenderer'},
        ]
      },
      gridFrameworkComponents: {
        addressColorRenderer: AddressColorCellRenderer
      },
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      functionList: [],
      employeeList: [],
      responsibleEmployeeList: [],
      selectedResponsibleEmployee: undefined,
      showDialog: false,
      dialogTitle: '',
      showDeleteDialog: false,
      loading: false
    }
  },

  watch: {
    addressId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.fetchResponsibleEmployeeList()
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isEnableResponsibleEmployeeButtons (): boolean {
      return !!this.selectedResponsibleEmployee
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    }
  },

  methods: {
    onAddResponsibleEmployeeClick (): void {
      this.dialogTitle = this.$t('masterData.addresses.addFunction').toString()
      this.selectedResponsibleEmployee = ResponsibleEmployee.createEmpty()
      this.showDialog = true
    },

    onEditResponsibleEmployeeClick (): void {
      this.dialogTitle = this.$t('masterData.addresses.editFunction').toString()
      this.showDialog = true
    },

    async createNewResponsibleEmployee (data: ResponsibleEmployee): Promise<void> {
      if(this.addressId) {
        const payloadData: VerantwortungsInput = {
          Mitarbeiter: data.employeeId,
          VarantwortungsArtID: data.functionId,
          ID: data.id
        }
        const payload: UpdateVerantwortungsDataRequest = {
          Action: 'Insert',
          Adresse: this.addressId,
          Data: payloadData
        }
        try {
          this.loading = true
          const response: ResponseBase = await this.$store.dispatch(ADDRESS_RESPONSIBLE_EMPLOYEE, payload)
          if (response && !response.IsError) {
            this.loading = false
            this.closeDialog()
            this.selectedResponsibleEmployee = undefined
            this.messageSnackbar = response.Result!
            this.snackbarState = SnackbarStateEnum.Success
            this.showSnackbar = true
            this.fetchResponsibleEmployeeList()
          } else {
            this.loading = false
            this.messageSnackbar = response.Result!
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch (e) {
          this.loading = false
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      }
    },

    async editResponsibleEmployee (data: ResponsibleEmployee): Promise<void> {
      if(this.addressId) {
        const payloadData: VerantwortungsInput = {
          Mitarbeiter: data.employeeId,
          VarantwortungsArtID: data.functionId,
          ID: data.id
        }
        const payload: UpdateVerantwortungsDataRequest = {
          Action: 'Update',
          Adresse: this.addressId,
          Data: payloadData
        }
        try {
          this.loading = true
          const response: ResponseBase = await this.$store.dispatch(ADDRESS_RESPONSIBLE_EMPLOYEE, payload)
          if (response && !response.IsError) {
            this.loading = false
            this.closeDialog()
            this.selectedResponsibleEmployee = undefined
            this.messageSnackbar = response.Result!
            this.snackbarState = SnackbarStateEnum.Success
            this.showSnackbar = true
            this.fetchResponsibleEmployeeList()
          } else {
            this.loading = false
            this.messageSnackbar = response.Result!
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch (e) {
          this.loading = false
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      }
    },

    closeDialog (): void {
      this.showDialog = false
      this.selectedResponsibleEmployee = undefined
      this.dialogTitle = ''
    },

    onDeleteResponsibleEmployeeClick (): void {
      this.showDeleteDialog = true
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    async onDeleteDialogSave (): Promise<void> {
      if(this.addressId && this.selectedResponsibleEmployee) {
        const payloadData: VerantwortungsInput = {
          Mitarbeiter: this.selectedResponsibleEmployee.employeeId,
          VarantwortungsArtID: this.selectedResponsibleEmployee.functionId,
          ID: this.selectedResponsibleEmployee.id
        }
        const payload: UpdateVerantwortungsDataRequest = {
          Action: 'Delete',
          Adresse: this.addressId,
          Data: payloadData
        }
        try {
          const response: ResponseBase = await this.$store.dispatch(ADDRESS_RESPONSIBLE_EMPLOYEE, payload)
          if (response && !response.IsError) {
            this.onDeleteDialogClose()
            this.selectedResponsibleEmployee = undefined
            this.messageSnackbar = response.Result!
            this.snackbarState = SnackbarStateEnum.Success
            this.showSnackbar = true
            this.fetchResponsibleEmployeeList()
          } else {
            this.onDeleteDialogClose()
            this.selectedResponsibleEmployee = undefined
            this.messageSnackbar = response.Result!
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      }
    },

    onResponsibleEmployeeRowClicked (params: any): void {
      this.selectedResponsibleEmployee = params.data
    },

    async fetchResponsibleEmployeeList (): Promise<void> {
      try {
        const response: VerantwortungsDataResponse = await this.$store.dispatch(FETCH_ADDRESS_RESPONSIBLE_EMPLOYEE_LIST, this.addressId)
        if (response && !response.IsError) {
          this.responsibleEmployeeList = ResponsibleEmployee.createFromResponse(response.Data)
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchData (): Promise<void> {
      await this.$store.dispatch(COMPANY_FETCH_COMPANY_STRUCTURE)
      this.employeeList = (this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]).employeeList.filter((item: Employee) => item.planbar)
      this.functionList = await this.$store.dispatch(FETCH_ADDRESS_FUNCTION_LIST, this.addressId)
    }

  },

  mounted () {
    this.fetchData()
    this.fetchResponsibleEmployeeList()
  }

})
